import GetActionHistoryListRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/action-history/request/GetActionHistoryListRequest";
import GetActionHistoryListResponse from "@/api/Main/dataSource/api/projects/task/i-service/models/action-history/response/GetActionHistoryListResponse";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import { TaskHistoryModel } from "../models";

export const mapGetTaskHistoryRequest = (taskId: number, pagination?: PageRequest) =>
  new GetActionHistoryListRequest({
    TaskId: taskId,
    Page: pagination,
  });

export const mapGetTaskHistoryResponse = (response: GetActionHistoryListResponse) => {
  return {
    Items: response.Items.map(
      (historyItem) =>
        new TaskHistoryModel({
          /**
           * id записи в истории
           */
          Id: historyItem.Id,
          /**
           * Данные пользователя который что-то поменял
           */
          Performer: historyItem.Performer,
          /**
           * Данные которые поменяли
           */
          Value: historyItem.Value,
          /**
           * Тип ответа (что именно изменилось в задаче)
           */
          ActionType: historyItem.ActionType,
          /**
           * Дата изменения
           */
          DateCreated: historyItem.DateCreated,
        }),
    ),
    Page: response.Page,
  };
};
